// Contract dates and rollover information for futures symbols.
// Each symbol has a list of arrays containing [expiry_date, contract_name].
// The system will automatically select the active contract based on the current date.

export const SYMBOL_CONTRACT_DATES = {
   
    "M6A": [
        ["2025-03-14", "JUN25"],
        ["2025-06-13", "SEP25"],
        ["2025-09-12", "DEC25"],
        ["2025-12-12", "MAR26"],
        ["2026-03-13", "JUN26"],
        ["2026-06-12", "SEP26"],
        ["2026-09-11", "DEC26"],
        ["2026-12-11", "MAR27"],
        ["2027-03-12", "JUN27"],
        ["2027-06-11", "SEP27"],
        ["2027-09-10", "DEC27"],
        ["2027-12-10", "MAR28"],
        ["2028-03-10", "JUN28"],
        ["2028-06-15", "SEP28"],
        ["2028-09-15", "DEC28"],
        ["2028-12-15", "MAR29"],
        ["2029-03-16", "JUN29"],
        ["2029-06-14", "SEP29"],
        ["2029-09-14", "DEC29"]
    ],

    "6B": [
        ["2025-03-14", "JUN25"],
        ["2025-06-13", "SEP25"],
        ["2025-09-12", "DEC25"],
        ["2025-12-12", "MAR26"],
        ["2026-03-13", "JUN26"],
        ["2026-06-12", "SEP26"],
        ["2026-09-11", "DEC26"],
        ["2026-12-11", "MAR27"],
        ["2027-03-12", "JUN27"],
        ["2027-06-11", "SEP27"],
        ["2027-09-10", "DEC27"],
        ["2027-12-10", "MAR28"],
        ["2028-03-10", "JUN28"],
        ["2028-06-15", "SEP28"],
        ["2028-09-15", "DEC28"],
        ["2028-12-15", "MAR29"],
        ["2029-03-16", "JUN29"],
        ["2029-06-14", "SEP29"],
        ["2029-09-14", "DEC29"],
        ["2029-12-14", "MAR30"]
    ],
    
    "6C": [
        ["2025-03-14", "JUN25"],
        ["2025-06-13", "SEP25"],
        ["2025-09-12", "DEC25"],
        ["2025-12-12", "MAR26"],
        ["2026-03-13", "JUN26"],
        ["2026-06-12", "SEP26"],
        ["2026-09-11", "DEC26"],
        ["2026-12-11", "MAR27"],
        ["2027-03-12", "JUN27"],
        ["2027-06-11", "SEP27"],
        ["2027-09-10", "DEC27"],
        ["2027-12-10", "MAR28"],
        ["2028-03-10", "JUN28"],
        ["2028-06-16", "SEP28"],
        ["2028-09-15", "DEC28"],
        ["2028-12-15", "MAR29"],
        ["2029-03-16", "JUN29"],
        ["2029-06-14", "SEP29"],
        ["2029-09-14", "DEC29"],
        ["2029-12-14", "MAR30"]
    ],

    "6E": [
        ["2025-03-14", "JUN25"],
        ["2025-06-13", "SEP25"],
        ["2025-09-12", "DEC25"],
        ["2025-12-12", "MAR26"],
        ["2026-03-13", "JUN26"],
        ["2026-06-12", "SEP26"],
        ["2026-09-11", "DEC26"],
        ["2026-12-11", "MAR27"],
        ["2027-03-12", "JUN27"],
        ["2027-06-11", "SEP27"],
        ["2027-09-10", "DEC27"],
        ["2027-12-10", "MAR28"],
        ["2028-03-10", "JUN28"],
        ["2028-06-15", "SEP28"],
        ["2028-09-15", "DEC28"],
        ["2028-12-15", "MAR29"],
        ["2029-03-16", "JUN29"],
        ["2029-06-14", "SEP29"],
        ["2029-09-14", "DEC29"],
        ["2029-12-14", "MAR30"]
    ],

    "M6E": [
        ["2025-03-14", "JUN25"],
        ["2025-06-13", "SEP25"],
        ["2025-09-12", "DEC25"],
        ["2025-12-12", "MAR26"],
        ["2026-03-13", "JUN26"],
        ["2026-06-12", "SEP26"],
        ["2026-09-11", "DEC26"],
        ["2026-12-11", "MAR27"],
        ["2027-03-12", "JUN27"],
        ["2027-06-11", "SEP27"],
        ["2027-09-10", "DEC27"],
        ["2027-12-10", "MAR28"],
        ["2028-03-10", "JUN28"],
        ["2028-06-15", "SEP28"],
        ["2028-09-15", "DEC28"],
        ["2028-12-15", "MAR29"],
        ["2029-03-16", "JUN29"],
        ["2029-06-14", "SEP29"],
        ["2029-09-14", "DEC29"],
        ["2029-12-14", "MAR30"]
    ],
    
    "6J": [
        ["2025-03-14", "JUN25"],
        ["2025-06-13", "SEP25"],
        ["2025-09-12", "DEC25"],
        ["2025-12-12", "MAR26"],
        ["2026-03-13", "JUN26"],
        ["2026-06-12", "SEP26"],
        ["2026-09-11", "DEC26"],
        ["2026-12-11", "MAR27"],
        ["2027-03-12", "JUN27"],
        ["2027-06-11", "SEP27"],
        ["2027-09-10", "DEC27"],
        ["2027-12-10", "MAR28"],
        ["2028-03-10", "JUN28"],
        ["2028-06-15", "SEP28"],
        ["2028-09-15", "DEC28"],
        ["2028-12-15", "MAR29"],
        ["2029-03-16", "JUN29"],
        ["2029-06-14", "SEP29"],
        ["2029-09-14", "DEC29"],
        ["2029-12-14", "MAR30"]
    ],

    "6S": [
        ["2025-03-14", "JUN25"],
        ["2025-06-13", "SEP25"],
        ["2025-09-12", "DEC25"],
        ["2025-12-12", "MAR26"],
        ["2026-03-13", "JUN26"],
        ["2026-06-12", "SEP26"],
        ["2026-09-11", "DEC26"],
        ["2026-12-11", "MAR27"],
        ["2027-03-12", "JUN27"],
        ["2027-06-11", "SEP27"],
        ["2027-09-10", "DEC27"],
        ["2027-12-10", "MAR28"],
        ["2028-03-10", "JUN28"],
        ["2028-06-15", "SEP28"],
        ["2028-09-15", "DEC28"],
        ["2028-12-15", "MAR29"],
        ["2029-03-16", "JUN29"],
        ["2029-06-14", "SEP29"],
        ["2029-09-14", "DEC29"],
        ["2029-12-14", "MAR30"]
    ],

    "CL": [
        ["2025-03-18", "MAY25"],
        ["2025-04-17", "JUN25"],
        ["2025-05-16", "JUL25"],
        ["2025-06-17", "AUG25"],
        ["2025-07-18", "SEP25"],
        ["2025-08-18", "OCT25"],
        ["2025-09-18", "NOV25"],
        ["2025-10-17", "DEC25"],
        ["2025-11-18", "JAN26"],
        ["2025-12-17", "FEB26"],
        ["2026-01-15", "MAR26"],
        ["2026-02-18", "APR26"],
        ["2026-03-18", "MAY26"],
        ["2026-04-17", "JUN26"],
        ["2026-05-15", "JUL26"],
        ["2026-06-17", "AUG26"],
        ["2026-07-17", "SEP26"],
        ["2026-08-18", "OCT26"],
        ["2026-09-18", "NOV26"],
        ["2026-10-16", "DEC26"],
        ["2026-11-18", "JAN27"],
        ["2026-12-17", "FEB27"],
        ["2027-01-18", "MAR27"],
        ["2027-02-18", "APR27"],
        ["2027-03-18", "MAY27"],
        ["2027-04-16", "JUN27"],
        ["2027-05-18", "JUL27"],
        ["2027-06-18", "AUG27"],
        ["2027-07-16", "SEP27"],
        ["2027-08-18", "OCT27"],
        ["2027-09-17", "NOV27"],
        ["2027-10-18", "DEC27"],
        ["2027-11-17", "JAN28"],
        ["2027-12-16", "FEB28"],
        ["2028-01-18", "MAR28"],
        ["2028-02-18", "APR28"],
        ["2028-03-17", "MAY28"],
        ["2028-04-18", "JUN28"],
        ["2028-05-18", "JUL28"],
        ["2028-06-16", "AUG28"],
        ["2028-07-18", "SEP28"],
        ["2028-08-18", "OCT28"],
        ["2028-09-18", "NOV28"],
        ["2028-10-18", "DEC28"],
        ["2028-11-16", "JAN29"],
        ["2028-12-15", "FEB29"],
        ["2029-01-18", "MAR29"],
        ["2029-02-16", "APR29"],
        ["2029-03-16", "MAY29"],
        ["2029-04-18", "JUN29"],
        ["2029-05-18", "JUL29"],
        ["2029-06-18", "AUG29"],
        ["2029-07-18", "SEP29"],
        ["2029-08-17", "OCT29"],
        ["2029-09-18", "NOV29"],
        ["2029-10-18", "DEC29"],
        ["2029-11-15", "JAN30"],
        ["2029-12-17", "FEB30"],
        ["2030-01-18", "MAR30"],
        ["2030-02-18", "APR30"],
        ["2030-03-18", "MAY30"],
        ["2030-04-18", "JUN30"],
        ["2030-05-17", "JUL30"],
        ["2030-06-18", "AUG30"],
        ["2030-07-18", "SEP30"]
    ],
    
    "ES": [
        ["2025-03-18", "JUN25"],
        ["2025-06-16", "SEP25"],
        ["2025-09-16", "DEC25"],
        ["2025-12-16", "MAR26"],
        ["2026-03-17", "JUN26"],
        ["2026-06-15", "SEP26"],
        ["2026-09-15", "DEC26"],
        ["2026-12-15", "MAR27"],
        ["2027-03-16", "JUN27"],
        ["2027-06-14", "SEP27"],
        ["2027-09-14", "DEC27"],
        ["2027-12-14", "MAR28"],
        ["2028-03-14", "JUN28"],
        ["2028-06-13", "SEP28"],
        ["2028-09-12", "DEC28"],
        ["2028-12-12", "MAR29"],
        ["2029-03-13", "JUN29"],
        ["2029-06-12", "SEP29"],
        ["2029-09-18", "DEC29"],
        ["2029-12-18", "MAR30"]
    ],
    
    "FDAX": [
        ["2025-03-24", "JUN25"],
        ["2025-06-20", "SEP25"],
        ["2025-09-19", "DEC25"],
        ["2025-12-19", "MAR26"],
        ["2026-03-20", "JUN26"],
        ["2026-06-19", "SEP26"],
        ["2026-09-18", "DEC26"],
        ["2026-12-18", "MAR27"],
        ["2027-03-19", "JUN27"],
        ["2027-06-18", "SEP27"],
        ["2027-09-17", "DEC27"],
        ["2027-12-17", "MAR28"]
    ],

    "GC": [
        ["2025-03-28", "JUN25"],
        ["2025-05-29", "AUG25"],
        ["2025-07-30", "DEC25"],
        ["2025-11-26", "FEB26"],
        ["2026-01-29", "APR26"],
        ["2026-03-30", "JUN26"],
        ["2026-05-28", "AUG26"],
        ["2026-07-30", "DEC26"],
        ["2026-11-27", "FEB27"],
        ["2027-01-28", "APR27"],
        ["2027-03-30", "JUN27"],
        ["2027-05-28", "DEC27"],
        ["2027-11-29", "JUN28"],
        ["2028-05-30", "DEC28"],
        ["2028-11-29", "JUN29"],
        ["2029-05-30", "DEC29"],
        ["2029-11-29", "JUN30"],
        ["2030-05-30", "DEC30"]
    ],
    
    "HG": [
        ["2025-02-27", "MAY25"],
        ["2025-04-29", "JUL25"],
        ["2025-06-27", "SEP25"],
        ["2025-08-28", "DEC25"],
        ["2025-11-26", "MAR26"],
        ["2026-02-26", "MAY26"],
        ["2026-04-29", "JUL26"],
        ["2026-06-29", "SEP26"],
        ["2026-08-28", "DEC26"],
        ["2026-11-27", "MAR27"],
        ["2027-02-25", "MAY27"],
        ["2027-04-29", "JUL27"],
        ["2027-06-29", "SEP27"],
        ["2027-08-30", "DEC27"],
        ["2027-11-29", "MAR28"],
        ["2028-02-28", "MAY28"],
        ["2028-04-27", "JUL28"],
        ["2028-06-29", "SEP28"],
        ["2028-08-30", "DEC28"],
        ["2028-11-29", "MAR29"],
        ["2029-02-27", "MAY29"],
        ["2029-04-27", "JUL29"],
        ["2029-06-28", "SEP29"],
        ["2029-08-30", "DEC29"],
        ["2029-11-29", "MAR30"],
        ["2030-02-27", "MAY30"]
    ],
    
    "HO": [
        ["2025-04-14", "JUN25"],
        ["2025-05-14", "JUL25"],
        ["2025-06-12", "AUG25"],
        ["2025-07-16", "SEP25"],
        ["2025-08-14", "OCT25"],
        ["2025-09-15", "NOV25"],
        ["2025-10-16", "DEC25"],
        ["2025-11-12", "JAN26"],
        ["2025-12-15", "FEB26"],
        ["2026-01-14", "MAR26"],
        ["2026-02-11", "APR26"],
        ["2026-03-16", "MAY26"],
        ["2026-04-15", "JUN26"],
        ["2026-05-13", "JUL26"],
        ["2026-06-12", "AUG26"],
        ["2026-07-16", "SEP26"],
        ["2026-08-14", "OCT26"],
        ["2026-09-15", "NOV26"],
        ["2026-10-15", "DEC26"],
        ["2026-11-12", "JAN27"],
        ["2026-12-15", "FEB27"],
        ["2027-01-14", "MAR27"],
        ["2027-02-11", "APR27"],
        ["2027-03-16", "MAY27"],
        ["2027-04-15", "JUN27"],
        ["2027-05-13", "JUL27"],
        ["2027-06-15", "AUG27"],
        ["2027-07-15", "SEP27"],
        ["2027-08-16", "OCT27"],
        ["2027-09-15", "NOV27"],
        ["2027-10-14", "DEC27"],
        ["2027-11-15", "JAN28"],
        ["2027-12-16", "FEB28"],
        ["2028-01-14", "MAR28"],
        ["2028-02-14", "APR28"],
        ["2028-03-16", "MAY28"],
        ["2028-04-13", "JUN28"],
        ["2028-05-16", "JUL28"],
        ["2028-06-15", "AUG28"],
        ["2028-07-14", "SEP28"],
        ["2028-08-16", "OCT28"],
        ["2028-09-14", "NOV28"],
        ["2028-10-16", "DEC28"],
        ["2028-11-15", "JAN29"]
    ],
    
    "MCL": [
        ["2025-03-18", "MAY25"],
        ["2025-04-17", "JUN25"],
        ["2025-05-16", "JUL25"],
        ["2025-06-17", "AUG25"],
        ["2025-07-18", "SEP25"],
        ["2025-08-18", "OCT25"],
        ["2025-09-18", "NOV25"],
        ["2025-10-17", "DEC25"],
        ["2025-11-18", "JAN26"],
        ["2025-12-17", "FEB26"],
        ["2026-01-15", "MAR26"],
        ["2026-02-18", "APR26"],
        ["2026-03-18", "MAY26"],
        ["2026-04-17", "JUN26"],
        ["2026-05-15", "JUL26"],
        ["2026-06-17", "AUG26"],
        ["2026-07-17", "SEP26"],
        ["2026-08-18", "OCT26"],
        ["2026-09-18", "NOV26"],
        ["2026-10-16", "DEC26"],
        ["2026-11-18", "JAN27"],
        ["2026-12-17", "FEB27"],
        ["2027-01-18", "MAR27"],
        ["2027-02-18", "APR27"],
        ["2027-03-18", "MAY27"],
        ["2027-04-16", "JUN27"],
        ["2027-05-18", "JUL27"],
        ["2027-06-18", "AUG27"],
        ["2027-07-16", "SEP27"],
        ["2027-08-18", "OCT27"],
        ["2027-09-17", "NOV27"],
        ["2027-10-18", "DEC27"],
        ["2027-11-17", "JAN28"],
        ["2027-12-16", "FEB28"],
        ["2028-01-18", "MAR28"],
        ["2028-02-18", "APR28"],
        ["2028-03-17", "MAY28"],
        ["2028-04-18", "JUN28"],
        ["2028-05-18", "JUL28"],
        ["2028-06-16", "AUG28"],
        ["2028-07-18", "SEP28"],
        ["2028-08-18", "OCT28"],
        ["2028-09-18", "NOV28"],
        ["2028-10-18", "DEC28"],
        ["2028-11-16", "JAN29"],
        ["2028-12-15", "FEB29"],
        ["2029-01-18", "MAR29"],
        ["2029-02-16", "APR29"],
        ["2029-03-16", "MAY29"],
        ["2029-04-18", "JUN29"],
        ["2029-05-18", "JUL29"],
        ["2029-06-18", "AUG29"],
        ["2029-07-18", "SEP29"],
        ["2029-08-17", "OCT29"],
        ["2029-09-18", "NOV29"],
        ["2029-10-18", "DEC29"],
        ["2029-11-15", "JAN30"],
        ["2029-12-17", "FEB30"],
        ["2030-01-18", "MAR30"],
        ["2030-02-18", "APR30"],
        ["2030-03-18", "MAY30"],
        ["2030-04-18", "JUN30"],
        ["2030-05-17", "JUL30"],
        ["2030-06-18", "AUG30"],
        ["2030-07-18", "SEP30"]
    ],

    "MES": [
        ["2025-03-18", "JUN25"],
        ["2025-06-16", "SEP25"],
        ["2025-09-16", "DEC25"],
        ["2025-12-16", "MAR26"],
        ["2026-03-17", "JUN26"],
        ["2026-06-15", "SEP26"],
        ["2026-09-15", "DEC26"],
        ["2026-12-15", "MAR27"],
        ["2027-03-16", "JUN27"],
        ["2027-06-14", "SEP27"],
        ["2027-09-14", "DEC27"],
        ["2027-12-14", "MAR28"],
        ["2028-03-14", "JUN28"],
        ["2028-06-13", "SEP28"],
        ["2028-09-12", "DEC28"],
        ["2028-12-12", "MAR29"],
        ["2029-03-13", "JUN29"],
        ["2029-06-12", "SEP29"],
        ["2029-09-18", "DEC29"],
        ["2029-12-18", "MAR30"]
    ],
    
    "MGC": [
        ["2025-03-28", "JUN25"],
        ["2025-05-29", "AUG25"],
        ["2025-07-30", "DEC25"],
        ["2025-11-26", "FEB26"],
        ["2026-01-29", "APR26"],
        ["2026-03-30", "JUN26"],
        ["2026-05-28", "AUG26"],
        ["2026-07-30", "DEC26"],
        ["2026-11-27", "FEB27"],
        ["2027-01-28", "APR27"],
        ["2027-03-30", "JUN27"],
        ["2027-05-28", "DEC27"],
        ["2027-11-29", "JUN28"],
        ["2028-05-30", "DEC28"],
        ["2028-11-29", "JUN29"],
        ["2029-05-30", "DEC29"],
        ["2029-11-29", "JUN30"],
        ["2030-05-30", "DEC30"]
    ],
    
    "MNQ": [
        ["2025-03-18", "JUN25"],
        ["2025-06-16", "SEP25"],
        ["2025-09-16", "DEC25"],
        ["2025-12-16", "MAR26"],
        ["2026-03-17", "JUN26"],
        ["2026-06-15", "SEP26"],
        ["2026-09-15", "DEC26"],
        ["2026-12-15", "MAR27"]
    ],
    
    "MYM": [
        ["2025-03-18", "JUN25"],
        ["2025-06-16", "SEP25"],
        ["2025-09-16", "DEC25"],
        ["2025-12-16", "MAR26"]
    ],

    "M2K": [
        ["2025-03-19", "JUN25"],
        ["2025-06-17", "SEP25"],
        ["2025-09-17", "DEC25"],
        ["2025-12-17", "MAR26"],
        ["2026-03-18", "JUN26"]
    ],

    "EMD": [
        ["2025-03-14", "JUN25"],
        ["2025-06-12", "SEP25"],
        ["2025-09-12", "DEC25"],
        ["2025-12-12", "MAR26"],
        ["2026-03-13", "JUN26"]
    ],

    "NKD": [
        ["2025-03-12", "JUN25"],
        ["2025-06-11", "SEP25"],
        ["2025-09-10", "DEC25"],
        ["2025-12-10", "MAR26"],
        ["2026-03-11", "JUN26"],
        ["2026-06-10", "SEP26"],
        ["2026-09-09", "DEC26"],
        ["2026-12-09", "MAR27"],
        ["2027-03-10", "JUN27"],
        ["2027-06-09", "SEP27"],
        ["2027-09-08", "DEC27"],
        ["2027-12-08", "MAR28"]
    ],
    
    "NG": [
        ["2025-03-27", "MAY25"],
        ["2025-04-28", "JUN25"],
        ["2025-05-28", "JUL25"],
        ["2025-06-26", "AUG25"],
        ["2025-07-29", "SEP25"],
        ["2025-08-27", "OCT25"],
        ["2025-09-26", "NOV25"],
        ["2025-10-29", "DEC25"],
        ["2025-11-25", "JAN26"],
        ["2025-12-29", "FEB26"],
        ["2026-01-28", "MAR26"],
        ["2026-02-25", "APR26"],
        ["2026-03-27", "MAY26"],
        ["2026-04-28", "JUN26"],
        ["2026-05-27", "JUL26"],
        ["2026-06-26", "AUG26"],
        ["2026-07-29", "SEP26"],
        ["2026-08-27", "OCT26"],
        ["2026-09-28", "NOV26"],
        ["2026-10-28", "DEC26"],
        ["2026-11-25", "JAN27"],
        ["2026-12-29", "FEB27"],
        ["2027-01-27", "MAR27"],
        ["2027-02-24", "APR27"],
        ["2027-03-29", "MAY27"],
        ["2027-04-28", "JUN27"],
        ["2027-05-26", "JUL27"],
        ["2027-06-28", "AUG27"],
        ["2027-07-28", "SEP27"],
        ["2027-08-27", "OCT27"],
        ["2027-09-28", "NOV27"],
        ["2027-10-27", "DEC27"],
        ["2027-11-26", "JAN28"],
        ["2027-12-29", "FEB28"],
        ["2028-01-27", "MAR28"],
        ["2028-02-25", "APR28"],
        ["2028-03-29", "MAY28"],
        ["2028-04-26", "JUN28"],
        ["2028-05-26", "JUL28"],
        ["2028-06-28", "AUG28"],
        ["2028-07-27", "SEP28"],
        ["2028-08-29", "OCT28"],
        ["2028-09-27", "NOV28"],
        ["2028-10-27", "DEC28"],
        ["2028-11-28", "JAN29"],
        ["2028-12-27", "FEB29"],
        ["2029-01-29", "MAR29"],
        ["2029-02-26", "APR29"],
        ["2029-03-27", "MAY29"],
        ["2029-04-26", "JUN29"],
        ["2029-05-29", "JUL29"],
        ["2029-06-27", "AUG29"],
        ["2029-07-27", "SEP29"],
        ["2029-08-29", "OCT29"]
    ],

    "NQ": [
        ["2025-03-18", "JUN25"],
        ["2025-06-16", "SEP25"],
        ["2025-09-16", "DEC25"],
        ["2025-12-16", "MAR26"],
        ["2026-03-17", "JUN26"],
        ["2026-06-15", "SEP26"],
        ["2026-09-15", "DEC26"],
        ["2026-12-15", "MAR27"]
    ],

    "PA": [
        ["2025-03-03", "JUN25"],
        ["2025-06-02", "SEP25"],
        ["2025-09-02", "DEC25"],
        ["2025-12-01", "MAR26"],
        ["2026-03-02", "JUN26"],
        ["2026-06-01", "SEP26"],
        ["2026-09-01", "DEC26"],
        ["2026-12-01", "MAR27"],
        ["2027-03-01", "JUN27"],
        ["2027-06-01", "SEP27"],
        ["2027-09-01", "DEC27"]
    ],

    "PL": [
        ["2025-03-27", "JUL25"],
        ["2025-06-26", "OCT25"],
        ["2025-09-26", "JAN26"],
        ["2025-12-29", "APR26"],
        ["2026-03-27", "JUL26"],
        ["2026-06-26", "OCT26"],
        ["2026-09-28", "JAN27"],
        ["2026-12-29", "APR27"],
        ["2027-03-29", "JUL27"],
        ["2027-06-28", "OCT27"]
    ],

    "RB": [
        ["2025-03-14", "MAY25"],
        ["2025-04-14", "JUN25"],
        ["2025-05-14", "JUL25"],
        ["2025-06-12", "AUG25"],
        ["2025-07-16", "SEP25"],
        ["2025-08-14", "OCT25"],
        ["2025-09-15", "NOV25"],
        ["2025-10-16", "DEC25"],
        ["2025-11-12", "JAN26"],
        ["2025-12-15", "FEB26"],
        ["2026-01-14", "MAR26"],
        ["2026-02-11", "APR26"],
        ["2026-03-16", "MAY26"],
        ["2026-04-15", "JUN26"],
        ["2026-05-13", "JUL26"],
        ["2026-06-12", "AUG26"],
        ["2026-07-16", "SEP26"],
        ["2026-08-14", "OCT26"],
        ["2026-09-15", "NOV26"],
        ["2026-10-15", "DEC26"],
        ["2026-11-12", "JAN27"],
        ["2026-12-15", "FEB27"],
        ["2027-01-14", "MAR27"],
        ["2027-02-11", "APR27"],
        ["2027-03-15", "MAY27"],
        ["2027-04-15", "JUN27"],
        ["2027-05-13", "JUL27"],
        ["2027-06-15", "AUG27"],
        ["2027-07-15", "SEP27"],
        ["2027-08-16", "OCT27"],
        ["2027-09-15", "NOV27"],
        ["2027-10-14", "DEC27"],
        ["2027-11-15", "JAN28"],
        ["2027-12-16", "FEB28"],
        ["2028-01-14", "MAR28"],
        ["2028-02-14", "APR28"],
        ["2028-03-16", "MAY28"],
        ["2028-04-13", "JUN28"],
        ["2028-05-16", "JUL28"],
        ["2028-06-15", "AUG28"],
        ["2028-07-14", "SEP28"],
        ["2028-08-16", "OCT28"],
        ["2028-09-14", "NOV28"],
        ["2028-10-16", "DEC28"],
        ["2028-11-15", "JAN29"]
    ],

    "SI": [
        ["2025-02-27", "MAY25"],
        ["2025-04-29", "JUL25"],
        ["2025-06-27", "SEP25"],
        ["2025-08-28", "DEC25"],
        ["2025-11-26", "MAR26"],
        ["2026-02-26", "MAY26"],
        ["2026-04-29", "JUL26"],
        ["2026-06-29", "SEP26"],
        ["2026-08-28", "DEC26"],
        ["2026-11-27", "MAR27"],
        ["2027-02-25", "MAY27"],
        ["2027-04-29", "JUL27"],
        ["2027-06-29", "DEC27"],
        ["2027-11-29", "JUL28"],
        ["2028-06-29", "DEC28"],
        ["2028-11-29", "JUL29"],
        ["2029-06-28", "DEC29"]
    ],
    
    "YM": [
        ["2025-03-18", "JUN25"],
        ["2025-06-16", "SEP25"],
        ["2025-09-16", "DEC25"],
        ["2025-12-16", "MAR26"]
    ],
    
    "ZL": [
        ["2025-02-20", "MAY25"],
        ["2025-04-22", "JUL25"],
        ["2025-06-18", "DEC25"],
        ["2025-11-19", "JAN26"],
        ["2025-12-19", "MAR26"],
        ["2026-02-19", "MAY26"],
        ["2026-04-22", "JUL26"],
        ["2026-06-18", "DEC26"],
        ["2026-11-19", "JAN27"],
        ["2026-12-22", "MAR27"],
        ["2027-02-18", "MAY27"],
        ["2027-04-22", "JUL27"],
        ["2027-06-22", "DEC27"],
        ["2027-11-22", "JUL28"],
        ["2028-06-22", "DEC28"]
    ],
    
    "ZM": [
        ["2025-02-14", "MAY25"],
        ["2025-04-16", "JUL25"],
        ["2025-06-16", "DEC25"],
        ["2025-11-14", "JAN26"],
        ["2025-12-17", "MAR26"],
        ["2026-02-13", "MAY26"],
        ["2026-04-17", "JUL26"],
        ["2026-06-16", "DEC26"],
        ["2026-11-16", "JAN27"],
        ["2026-12-17", "MAR27"],
        ["2027-02-15", "MAY27"],
        ["2027-04-19", "JUL27"],
        ["2027-06-17", "DEC27"],
        ["2027-11-17", "JUL28"],
        ["2028-06-19", "DEC28"],
        ["2028-11-19", "DEC28"]
    ]

}; 


//  TO ADD WITH NUMBER FORMAT
//       30-Year T-Bond
//      "ZB"
//       Ultra T-Bond
//      "UB"   
//       Corn
//      "ZC"
//       5-Year T-Note
//      "ZF"
//      10-Year T-Note
//      "ZN"
//   Soybeans
//      "ZS"
//       2-Year T-Note
//      "ZT"
 